/**
 * Section Schema Auto-Registration
 * Automatically registers all section schemas with the registry
 */

import { sectionSchemaRegistry } from '@/lib/section-schema-registry'

// Import section components that have elementSchema
import SectionHeroV3 from '@/components/sections/v3/section-hero-v3'
import SectionHeroLearningPath from '@/components/sections/v4/section-hero-v4'

import type { SectionElementSchema } from '@/types/element-schema.type'

/**
 * Components with elementSchema static property
 */
type ComponentWithSchema = { elementSchema?: SectionElementSchema }

/**
 * List of components with element schemas
 * Add new components here as they are defined
 */
const componentsWithSchemas: ComponentWithSchema[] = [SectionHeroV3, SectionHeroLearningPath]

/**
 * Register all section schemas
 * Call this once at app initialization
 */
export function registerAllSectionSchemas(): void {
  componentsWithSchemas.forEach(component => {
    if (component.elementSchema) {
      sectionSchemaRegistry.register(component.elementSchema)
    }
  })
}

/**
 * Get all registered schemas
 */
export function getAllSchemas(): SectionElementSchema[] {
  return sectionSchemaRegistry.getAll()
}

/**
 * Check if all expected schemas are registered
 */
export function validateSchemaRegistration(): { valid: boolean; missing: string[] } {
  const expectedTypes = ['SectionHeroV3', 'SectionHeroLearningPath']
  const missing: string[] = []

  expectedTypes.forEach(type => {
    if (!sectionSchemaRegistry.has(type)) {
      missing.push(type)
    }
  })

  return {
    valid: missing.length === 0,
    missing,
  }
}
